import { Outlet, createFileRoute } from "@tanstack/react-router";
import { parsePartnerSearch, type PartnerSearch } from "../../../features/partner/lib/partner-search";

/**
 * `/{lang}/partner/*`: the organiser's partner dashboard. Private: noindex
 * here, not in the sitemap, and never edge-cached (server.ts no-store list).
 * Rendered in the browser only (the session is), so the server sends the
 * loading frame and nothing about any organiser.
 */
export const Route = createFileRoute("/$lang/_partner/partner")({
  validateSearch: (search: Record<string, unknown>): PartnerSearch => parsePartnerSearch(search),
  head: () => ({ meta: [{ name: "robots", content: "noindex, nofollow" }] }),
  component: () => <Outlet />,
});
